<div id="about-library" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title">About Library</h2>

        <!-- Bootstrap Carousel -->
        <div id="libraryCarousel" class="carousel slide my-4" data-bs-ride="carousel" data-bs-interval="3000">
          <div class="carousel-inner">

            <div class="carousel-item active">
              <img src="/assets/img/library/1.jpg" class="d-block w-100" alt="Library Image 1" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/2.jpg" class="d-block w-100" alt="Library Image 2" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/3.jpg" class="d-block w-100" alt="Library Image 3" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/4.jpg" class="d-block w-100" alt="Library Image 4" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/5.jpg" class="d-block w-100" alt="Library Image 5" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/6.jpg" class="d-block w-100" alt="Library Image 6" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/7.jpg" class="d-block w-100" alt="Library Image 7" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/8.jpg" class="d-block w-100" alt="Library Image 8" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/9.jpg" class="d-block w-100" alt="Library Image 9" />
            </div>
            <div class="carousel-item">
              <img src="/assets/img/library/10.jpg" class="d-block w-100" alt="Library Image 9" />
            </div>

          </div>

          <!-- Carousel controls -->
          <button class="carousel-control-prev" type="button" data-bs-target="#libraryCarousel" data-bs-slide="prev">
            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Previous</span>
          </button>
          <button class="carousel-control-next" type="button" data-bs-target="#libraryCarousel" data-bs-slide="next">
            <span class="carousel-control-next-icon" aria-hidden="true"></span>
            <span class="visually-hidden">Next</span>
          </button>
        </div>

        <!-- Text Content -->
        <div class="library-content">
          <p>
            The College library is a vital resource for students, faculty, and staff, serving as a hub for academic research, study, and collaboration. It provides quiet study rooms equipped with comfortable seating and desks. Several computer systems are provided with high-speed Internet access for study and research.
          </p>
          <p>
            The library at Shah Satnam Ji Girls’ College has recently benefited from a generous book donation program, significantly enhancing its collection and resources. This initiative has brought in a wide array of books across various subjects, providing students with access to the latest academic materials, classic literature, and contemporary works.
          </p>
          <p>
            The donation has enriched the library’s offerings, supporting the educational and intellectual growth of the College community. The library staff has meticulously catalogued the new additions, ensuring that these are easily accessible to all students and faculty. This contribution reflects the commitment of the College and its supporters to fostering a rich learning environment and promoting a culture of intellectualism through reading.
          </p>
        </div>

      </div>
    </div>
  </div>
</div>
